define(['core/iterate'], function(iterate) {
        return {
            getStandartNodes() {

            },
            create: function(DOMEl, onClose) {

                var prevClass = "";

                this.isOpen = false;
                this.el;

                var closeModalsBtns = [];
                
                DOMEl.close.addEventListener("click", function () {
                    close();
                });

                DOMEl.bg.addEventListener("click", function () {
                    close();
                });

                document.addEventListener("keydown", function (evt) {
                    var isEscape = (evt.key === "Escape" || evt.key === "Esc");
                    if (isEscape) {
                        close();
                    }
                });

                function open(options, onDOMLoaded, template) {
                    iterate(DOMEl.blur, function (node) {
                        if(node) {
                            node.classList.add("blur");
                        }
                    });
                    prevClass = template ? template.getAttribute("data-class") : options.class;
                    DOMEl.content.innerHTML = template ? template.innerHTML : options.content;
                    DOMEl.title.innerText = template ? template.getAttribute("data-title") : options.title;
                    DOMEl.modal.classList.add(prevClass || "opened");
                    DOMEl.modal.classList.remove("disabled");
                    closeModalsBtns = document.querySelectorAll(".close-sb-modal_js");
                    iterate(closeModalsBtns,function (item) {
                        item.addEventListener("click",close);
                    });
                    onDOMLoaded(DOMEl.modal);
                    this.el = DOMEl.modal;
                    this.isOpen = true;
                }

                function close(onClose2) {
                     iterate(closeModalsBtns,function (item) {
                        item.removeEventListener("click",close);
                     });
                    DOMEl.modal.classList.add("disabled");

                    if(prevClass) {
                        setTimeout(() => {
                            DOMEl.modal.classList.remove(prevClass);
                        }, 200)
                    }
                    
                    document.body.classList.remove("noscroll");
                    iterate(DOMEl.blur, function (node) {
                        if(node) {
                            node.classList.remove("blur");
                        }
                    });
                    if (typeof onClose === "function") onClose(DOMEl.modal);
                    if (typeof onClose2 === "function") onClose2(DOMEl.modal);
                    this.isOpen = false;
                }

                return {
                    open: open,
                    close: close,
                    isOpen: this.isOpen,
                    el: this.el
                }

            }
        }
    }
);
